import { StyledTooltip } from 'components';
import { GridEditInputCell, GridRenderEditCellParams } from '@mui/x-data-grid-premium';

const EditInputCell = (props: GridRenderEditCellParams) => {
  const { error } = props;

  return (
    <StyledTooltip open={!!error} title={error}>
      <GridEditInputCell {...props} />
    </StyledTooltip>
  );
};

export default EditInputCell;
